export const formatMoney = (money: number | null | undefined) => {
  if (money === null || money === undefined) {
    return null;
  }
  const formatter = new Intl.NumberFormat("ja-JP", {
    style: "decimal",
  });
  return `¥${formatter.format(money)}`;
};
